module.exports = __webpack_public_path__ + "img/silver2.18f610a7.png";